<template>
    <main class="room">
        <room-docs></room-docs>
        <open-tok></open-tok>
        <chat></chat>
    </main>
</template>

<script>
	import OpenTok from "./opentok/OpenTok.vue";
    import Chat from "./chat/Chat.vue";
	import store from './store/room-store';
    import RoomDocs from "./RoomDocs";

    export default {
		store,
        name: 'ActiveRoom',
		components: {
            RoomDocs,
            OpenTok,
            Chat
        }
    }
</script>
